import React from "react";
import styles from "../../static/css/pages.module.css";
import ServerTimeout from "../server/timeout";
import ServerError from "../server/error";
import ServerRegister from "../server/register";
import ServerWaiting from "../server/loading";
import Title from "../../components/title/title";
import Icon from "../../components/icons/icons";
import Moment from "react-moment";
import Button from "../../components/form/button/button";
import {connect} from "react-redux";
import ieSvg from "../../components/icons/ieSvg";
import moment from "moment";
import EmptyData from "./empty";

class PanelTaxes extends React.Component {
  componentDidMount() {
    document.title = "Мои налоги | Самозанятые";
    ieSvg();
    this.initDateFilter();
    this.initPayTo();
  }

  componentDidUpdate() {
    ieSvg();
    this.initDateFilter();
    this.initPayTo();
  }

  initDateFilter = () => {
    const date = document.querySelectorAll("em");
    date.forEach(function(e){
      const dataValue = e.innerHTML;
      const dataParent = e.closest("[data-tax]").previousSibling;
      if (dataParent) {
        const dataParentVal = dataParent.querySelector("em").innerHTML;
        if (dataValue === dataParentVal) {
          e.parentElement.className += " hidden";
        }
      }
    });
  }

  initPayTo = () => {
    let currentDate = Date.now();
    let taxItem = document.querySelectorAll("[data-tax]");
    taxItem.forEach(function(e){
      let payDate = e.querySelector("[data-till]");
      let payTo = e.querySelector("time");
      let timeDate = payTo.getAttribute("datetime") - currentDate;
      let label = e.querySelector("[data-label]");
      if(timeDate > 0) {
        label.innerHTML = 'оплатить до';
        payDate.setAttribute('data-success', true)
      }
      else {
        label.innerHTML = 'не оплачен';
        e.querySelector("[data-amount]").style.color = 'rgb(var(--color-warning))';
      }
    })
  };

  handleSubmit = (e, data) => {
   window.getDataToMobileApp = () => data;
   window.getDataToMobileApp();
  };

  render() {
    const partner = this.props.partnerProperties.items;
    if(this.props.taxes.items && partner) {
      switch (this.props.taxes.items.result.status) {
        case "TIMEOUT":
          return <ServerTimeout pageTitle="Мои налоги" pageIcon="icon_menu-taxes" />;
        case "ERROR":
          switch (this.props.taxes.items.result.errorCode) {
            case "TAXPAYER_UNBOUND":
            case "TAXPAYER_UNREGISTERED":
              return <ServerRegister pageTitle="Мои налоги" pageIcon="icon_menu-taxes" errorMessage={this.props.taxes.items.result.errorMessage}/>
            default:
              return <ServerError pageTitle="Мои налоги" pageIcon="icon_menu-taxes" errorMessage={this.props.taxes.items.result.errorMessage}/>
          }
        case "SUCCESS":
          let autoPaymentTax = partner?.data?.autoPaymentTax;
          if(this.props.taxes.items?.data[0]?.paymentDocuments.length > 0) {
            return (
              <div className={styles.content}>
                <div>
                  <div className="l-grid_pt-8 mobile_l-grid">
                    <div className="l-grid__item_1">{''}</div>
                    <div className="l-grid__item_6 mobile_l-grid__item_10 l-position_relative">
                      <Title icon="icon_menu-taxes" title="Мои налоги"/>
                      {autoPaymentTax ? <AutoPaymentLink/> : null}
                      <div>
                        {this.props.taxes.items.data[0].paymentDocuments.sort((b, a) => Date.parse(a.createTime) - Date.parse(b.createTime)).map((d, i) =>
                          <div  key={i} data-tax>
                            <div className={styles.history_header} data-date>
                              <Moment element="em" className="time" format="DD MMMM YYYY" local>
                                {moment.utc(d.createTime)}
                              </Moment>
                            </div>
                            <div className={`${styles.history_item} ${styles.content_text}`} data-stroke>
                              <div className="l-grid_pt-8">
                                <div className="l-grid__item_4 l-grid_align-middle">
                                  {d.type === 'TAX' ?
                                    'Налоговое начисление'
                                    :
                                    null
                                  }
                                  {d.type === 'CORRECTION' ?
                                    'Корректировка налога'
                                    :
                                    null
                                  }
                                  {d.type === 'PENALTY' ?
                                    'Пеня'
                                    :
                                    null
                                  }
                                  {d.type === 'DEBT' ?
                                    'Задолженность'
                                    :
                                    null
                                  }
                                  <div className={styles.status_error} data-till>
                                    <span data-label>оплатить до</span> <Moment format="DD MMMM YYYY" local>{d.dueDate}</Moment> (мск)
                                  </div>
                                </div>
                                {partner.data.paymentTax ?
                                  null :
                                  <div className="l-grid__item_3">{''}</div>
                                }
                                <div className="l-grid__item_1 l-grid_align-middle">
                                  <div className="text_sum" data-amount>
                                    {d.amount.replace('.', ',')}
                                  </div>
                                </div>
                                {partner.data.paymentTax ?
                                <div className="l-grid__item_3 l-grid_align-middle no-padding l-align_right">
                                  <form action={process.env.REACT_APP_SMZPAY} method="post" onSubmit={(e) => this.handleSubmit(e, d)}>
                                    <input name='address' hidden readOnly value={d.address} />
                                    <input name='amount' hidden readOnly value={d.amount} />
                                    <input name='code101' hidden readOnly value={d.code101} />
                                    <input name='code106' hidden readOnly value={d.code106} />
                                    <input name='code107' hidden readOnly value={d.code107} />
                                    <input name='code110' hidden readOnly value={d.code110} />
                                    <input name='createTime' hidden readOnly value={moment.utc(d.createTime).local().format('YYYY-MM-DDTHH:mm:ss.S')} />
                                    <input name='documentIndex' hidden readOnly value={d.documentIndex} />
                                    <input name='dueDate' hidden readOnly value={d.dueDate} />
                                    <input name='fullName' hidden readOnly value={d.fullName} />
                                    <input name='inn' hidden readOnly value={d.inn} />
                                    <input name='kbk' hidden readOnly value={d.kbk} />
                                    <input name='oktmo' hidden readOnly value={d.oktmo} />
                                    <input name='recipient' hidden readOnly value={d.recipient} />
                                    <input name='recipientAccountNumber' hidden readOnly value={d.recipientAccountNumber} />
                                    <input name='recipientBankAccountNumber' hidden readOnly value={d.recipientBankAccountNumber} />
                                    <input name='recipientBankBic' hidden readOnly value={d.recipientBankBic} />
                                    <input name='recipientBankName' hidden readOnly value={d.recipientBankName} />
                                    <input name='recipientInn' hidden readOnly value={d.recipientInn} />
                                    <input name='recipientKpp' hidden readOnly value={d.recipientKpp} />
                                    <input name='sourceId' hidden readOnly value={d.sourceId} />
                                    <input name='type' hidden readOnly value={d.type} />
                                    <Button type="submit" title="Оплатить" />
                                  </form>
                                </div>
                                  : null
                                }
                              </div>
                            </div>
                          </div>
                        )}
                        <EmptyData data={this.props.taxes.items.data[0].paymentDocuments} partner={partner.data}  />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
          else {
            return (
              <div className={styles.content}>
                <div>
                  <div className="l-grid_pt-8">
                    <div className="l-grid__item_1">{''}</div>
                    <div className="l-grid__item_6 l-position_relative">
                      <Title icon="icon_menu-taxes" title="Мои налоги"/>
                      {autoPaymentTax ? <AutoPaymentLink/>: null}
                      <EmptyData data={false} />
                     {/* <div className="l-align_center">
                        <Icon name="icon_zero-list" viewbox="0 0 227 120" />
                        <div className={styles.article}>
                          У вас нет налоговых начислений за период
                        </div>
                        <div className={styles.article}>{''}</div>
                        <div className={styles.article}>{''}</div>
                      </div>*/}
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        default:
          return <ServerWaiting  pageTitle="Мои налоги" waiting="Загружаем список налогов..."  pageIcon="icon_menu-taxes" />
      }
    }
    else {
      return <ServerWaiting  pageTitle="Мои налоги" waiting="Загружаем список налогов..."  pageIcon="icon_menu-taxes" />
    }
  }
}

const mapStateToProps = state => ({taxes: state.paymentDocument, partnerProperties: state.partnerProperties});

export default connect(mapStateToProps)(PanelTaxes);

const AutoPaymentLink = () => {
  return (
    <React.Fragment>
      <span>Настройте автооплату для налогов в разделе <a href={process.env.REACT_APP_ELF_URL + '?priv=true&replace=subscriptions_add&state=npd'}>
          Подписки
        </a>
      </span>
      <div className={styles.article}/>
    </React.Fragment>
  )
}